<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    style="fill: #fff"
    class=""
    viewBox="0 0 500 500"
    role="img"
    version="1.1"
    id="svg6095"
  >
    <svg viewBox="0 0 512 512" id=" " version="1.1">
      <path
        d="M94.3 197.1v69.7c0 20.3-5.6 33.5-27.4 33.5s-27.7-13.2-27.7-33.5v-69.7H8.8v77c-.1 33.1 22.8 45.1 57.6 45.1 33.8 0 58.7-11.9 58.7-45.2l-.1-76.9H94.3zM444.3 195.5c-15.7 0-36.8 3.7-49.2 9l.8 22.5c11.3-7.3 23.9-12.7 43.7-12.7 26.2 0 33.6 12.3 33.6 30.2h-21.5c-15.4 0-33.6 1.1-47.7 6.7-14.1 5.7-24.3 15.9-24.3 33.3 0 21.3 18.5 34.6 44.7 34.6 15.3 0 36.3-4.8 46.8-18.3h.5c.1 3.1.5 10.9 1.6 16.7h29.8l.1-77.8c-2.6-31.2-17.4-44.2-58.9-44.2zm-8.4 104.8c-12.8.2-23.5-5.8-23.5-17.8 0-17.5 17.8-21.3 39.3-21.3h21.5c0 25.5-17.4 38.7-37.3 39.1zM216.9 295.5c-27.2 0-42.5-19.3-42.5-41.9 0-21.2 13.3-41.4 41.9-41.4 10.2 0 19.3 1.3 31.7 6.2l.8-20.8c-11-3.2-23.2-4.8-32.5-4.8-44.8 0-74.2 21.6-74.2 62.5 0 36.4 28.7 58.5 74.2 58.5 10.8 0 21.3-1.3 33-3.7l-1-19.4c-8.2 2.8-20.2 4.8-31.4 4.8zM321.2 195.5h-54.5v118.2h31v-40.3h26.6c33.1 0 55.2-13.8 55.2-38.4.1-34.2-32.2-39.5-58.3-39.5zm.7 58.9h-24v-40.5h24c15.8 0 27.4 6.2 27.4 20.2 0 11.3-9.6 20.3-27.4 20.3z"
        id="path6092"
      />
    </svg>
  </svg>
</template>

<script>
export default {
  name: "UCPALogo"
};
</script>

<style>
</style>